/* Mobau Pro – anonymes Suchprotokoll (Agent I, 10/2026).
   Sendet, was gesucht und welche Produkte gezeigt wurden, an den eigenen Protokolldienst (Railway, EU),
   damit die Suche regelmäßig ausgewertet und verbessert werden kann.
   - Keine Cookies, keine Kunden-ID, keine IP-Speicherung; Sitzung = Zufallskennung je Seite, im sessionStorage nur mit Statistik-Einwilligung.
   - navigator.sendBeacon: blockiert nichts, Fehler werden verschluckt; ohne Beacon passiert einfach nichts.
   - Datenquelle: Ereignis „mobau:suche“ aus assets/mobau-suche.js (Dropdown, Ergebnisseite) + Klicks/Warenkorb per DOM. */
(function () {
  if (window.__mobauSuchlog) return;
  window.__mobauSuchlog = true;
  var ZIEL = 'https://suchprotokoll-production.up.railway.app/log';
  if (!navigator.sendBeacon || !window.JSON) return;

  var PAUSE_MS = 800, MAX_Q = 120, MAX_TREFFER = 12;

  function zufall() {
    var a = 'abcdefghijklmnopqrstuvwxyz0123456789', s = '';
    var c = window.crypto && crypto.getRandomValues ? crypto.getRandomValues(new Uint8Array(16)) : null;
    for (var i = 0; i < 16; i++) s += a[(c ? c[i] : Math.floor(Math.random() * 256)) % a.length];
    return s;
  }
  // Sitzungskennung: ohne Statistik-Einwilligung nur im Arbeitsspeicher der Seite (keine Speicherung auf dem Gerät,
  // TDDDG § 25); mit Einwilligung wie bisher im sessionStorage des Tabs. Widerruf löscht den Eintrag (D, 11.10.2026).
  function statistikErlaubt() {
    try { var cp = window.Shopify && window.Shopify.customerPrivacy; return !!(cp && cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed()); }
    catch (e) { return false; }
  }
  var sitzung = null;
  try { sitzung = sessionStorage.getItem('mobau_suchlog'); } catch (e) {}
  if (!sitzung) sitzung = zufall();
  function speichern(erlaubt) {
    try { if (erlaubt) sessionStorage.setItem('mobau_suchlog', sitzung); else sessionStorage.removeItem('mobau_suchlog'); } catch (e) {}
  }
  if (statistikErlaubt()) speichern(true);
  document.addEventListener('visitorConsentCollected', function (ev) { speichern(!!(ev && ev.detail && ev.detail.analyticsAllowed)); });

  function geraet() {
    try { return (window.matchMedia('(pointer: coarse)').matches || window.innerWidth < 768) ? 'mobil' : 'desktop'; }
    catch (e) { return 'desktop'; }
  }
  var vorschau = !!(window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main');

  function senden(e) {
    try {
      e.t = new Date().toISOString();
      e.sitzung = sitzung;
      e.geraet = geraet();
      if (vorschau) e.vorschau = 1;
      if (e.q) e.q = String(e.q).slice(0, MAX_Q);
      if (e.treffer) e.treffer = e.treffer.slice(0, MAX_TREFFER);
      navigator.sendBeacon(ZIEL, new Blob([JSON.stringify(e)], { type: 'text/plain;charset=UTF-8' }));
    } catch (err) { /* nie stören */ }
  }

  // ---- Dropdown: erst nach 800 ms Tipp-Pause (bzw. sofort bei Enter/Auswahl/Seitenwechsel) senden.
  var offen = null, timer = null, zuletzt = '';
  function dropdownAbschicken() {
    clearTimeout(timer); timer = null;
    if (!offen) return;
    var e = offen; offen = null;
    var schluessel = (e.q || '').toLowerCase();
    if (schluessel === zuletzt) return;      // gleiche Anfrage nicht doppelt (z. B. Feld neu fokussiert)
    zuletzt = schluessel;
    if (!e.anzahl) { e.quelle = 'dropdown'; e.art = 'null_treffer'; }
    senden(e);
  }

  // Zuletzt gezeigte Liste je Quelle — für Klick-Position und Suchbegriff beim Klick.
  var letzte = { dropdown: null, ergebnisseite: null };

  document.addEventListener('mobau:suche', function (ev) {
    var d = ev.detail || {};
    if (!d.art || !d.q) return;
    var e = {
      art: d.art, q: d.q, treffer: (d.treffer || []).map(String), anzahl: d.anzahl | 0,
      dauer_ms: d.dauer_ms != null ? Math.round(d.dauer_ms) : undefined
    };
    if (d.art === 'dropdown') {
      letzte.dropdown = { q: d.q };
      if (d.filter) e.filter = d.filter; /* K: Bedeutungstreffer im Dropdown kennzeichnen (liste/stufe) */
      offen = e;
      clearTimeout(timer); timer = setTimeout(dropdownAbschicken, PAUSE_MS);
    } else if (d.art === 'ergebnisseite') {
      letzte.ergebnisseite = { q: d.q, seite: d.seite || 1, proSeite: d.pro_seite || 48 };
      if (d.filter) e.filter = d.filter;
      if (d.kategorie) e.kategorie = d.kategorie;
      if (!e.anzahl) { e.quelle = 'ergebnisseite'; e.art = 'null_treffer'; }
      senden(e);
    }
  });

  function handleAus(a) {
    var m = a && a.getAttribute('href') && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function klickDaten(ziel) {
    // Dropdown
    var drop = ziel.closest('.ms-drop');
    if (drop && letzte.dropdown) {
      var a = ziel.closest('a[href]');
      if (!a) return null;
      var h = handleAus(a);
      if (h) {
        var liste = drop.querySelectorAll('.ms-drop__produkte a[href*="/products/"]'), pos = 0;
        for (var i = 0; i < liste.length; i++) if (liste[i] === a) { pos = i + 1; break; }
        return { quelle: 'dropdown', q: letzte.dropdown.q, klick_handle: h, klick_pos: pos || undefined };
      }
      var k = a.getAttribute('href').match(/\/collections\/([^/?#]+)/);
      if (k) return { quelle: 'dropdown', q: letzte.dropdown.q, kategorie: decodeURIComponent(k[1]) };
      return null;
    }
    // Ergebnisseite
    var seite = ziel.closest('#ms-seite');
    if (seite && letzte.ergebnisseite) {
      var karte = ziel.closest('.mb-card'); if (!karte) return null;
      var titel = karte.querySelector('.mb-card__title a') || karte.querySelector('a[href*="/products/"]');
      var li = karte.closest('li'), p = 0;
      if (li && li.parentNode) p = Array.prototype.indexOf.call(li.parentNode.children, li) + 1;
      var l = letzte.ergebnisseite;
      return { quelle: 'ergebnisseite', q: l.q, klick_handle: handleAus(titel),
               klick_pos: p ? p + (l.seite - 1) * l.proSeite : undefined };
    }
    return null;
  }

  // Klick auf ein Ergebnis (Maus, Touch, Tastatur-Enter auf Link lösen alle „click“ aus).
  document.addEventListener('click', function (ev) {
    var t = ev.target && ev.target.closest ? ev.target : null;
    if (!t || t.closest('form[data-mb-quickadd]')) return;   // Warenkorb-Knopf: eigenes Ereignis
    if (!t.closest('a[href]')) return;
    var d = klickDaten(t);
    if (!d || (!d.klick_handle && !d.kategorie)) return;
    dropdownAbschicken();
    d.art = 'klick';
    senden(d);
  }, true);

  // Enter mit markiertem Dropdown-Eintrag navigiert per JS (kein click) — Position aus der Markierung.
  document.addEventListener('keydown', function (ev) {
    if (ev.key !== 'Enter' || !ev.target || !ev.target.closest) return;
    var form = ev.target.closest('form');
    var drop = document.querySelector('.ms-drop:not([hidden]) .is-aktiv');
    if (drop && letzte.dropdown && form) {
      var d = klickDaten(drop);
      if (d && (d.klick_handle || d.kategorie)) { dropdownAbschicken(); d.art = 'klick'; senden(d); return; }
    }
    if (form && ev.target.matches && ev.target.matches('input[name="q"]')) {
      // Enter mitten im Tippen: die halbe Eingabe („wandfarbe wei“) nicht protokollieren — die Ergebnisseite
      // meldet gleich den vollständigen Begriff.
      if (offen && String(ev.target.value || '').trim().toLowerCase() !== String(offen.q || '').toLowerCase()) { clearTimeout(timer); offen = null; }
      else dropdownAbschicken();
    }
  }, true);

  // „In den Warenkorb“ direkt aus der Suche.
  document.addEventListener('submit', function (ev) {
    var sf = ev.target && ev.target.querySelector && /\/search(\?|$)/.test(ev.target.getAttribute('action') || '') ? ev.target.querySelector('input[name="q"]') : null;
    if (sf && offen && String(sf.value || '').trim().toLowerCase() !== String(offen.q || '').toLowerCase()) { clearTimeout(timer); offen = null; }
    var f = ev.target && ev.target.closest ? ev.target.closest('form[data-mb-quickadd]') : null;
    if (!f) return;
    var d = klickDaten(f);
    if (!d || !d.klick_handle) return;
    d.art = 'warenkorb';
    senden(d);
  }, true);

  // Offene Dropdown-Anfrage nicht verlieren, wenn die Seite verlassen wird.
  window.addEventListener('pagehide', dropdownAbschicken);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') dropdownAbschicken(); });
})();
